import axios from "axios";

export default class UsersService {
  static async updateEmail(userId: number, body: Object): Promise<any> {
    return await axios.patch(`/api/users/${userId}`, body, {
      withCredentials: true,
    });
  }
}
